import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'app-pagination',
    templateUrl: 'pagination.component.html'
})
export class PaginationComponent {
    //#region input properties
    @Input() pager: any;
    //#endregion

    //#region output properties
    @Output() onPageChanged: EventEmitter<number> = new EventEmitter();
    //#endregion

    //#region methods
    setPage(page: number): void {
        if (page <= this.pager.totalPages || page >= 1) {
            this.onPageChanged.emit(page);
        }
    }
    //#endregion
}